module.exports = __webpack_public_path__ + "img/logo.86ef58ba.png";